import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('painel: elemento #root não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
